import Repository from '@/app/shared/infrastructure/http/Repository';

export default class BillingRepository extends Repository {
    uri = '/api/billings';
}
